module.exports = __webpack_public_path__ + "media/images/official/top_mv2_sp_old-52971690556a7095dfd54a95a6db72ae.jpg";